// extracted by mini-css-extract-plugin
module.exports = {"signupContainer":"SignInForm_signupContainer__ViVcS","signupDescription":"SignInForm_signupDescription__c1a6Z"};